import { Phone, MessageCircle, Mail } from "lucide-react";

/**
 * MobileStickyBar — fixed bottom action bar shown ONLY on phones/tablets.
 * Three always-available actions: Call, WhatsApp, Email.
 * Reuses the same NAP as the rest of the site (single source of truth).
 */
const PHONE = "+254725979245";
const EMAIL = "contact@tafraenergy.com";
const WHATSAPP_URL = `https://wa.me/${PHONE.replace(/[^0-9]/g, "")}`;

const MobileStickyBar = () => {
  const items = [
    {
      key: "call",
      label: "Call",
      icon: Phone,
      href: `tel:${PHONE}`,
      accent: "var(--accent-blue)",
      testid: "msb-call",
    },
    {
      key: "whatsapp",
      label: "WhatsApp",
      icon: MessageCircle,
      href: WHATSAPP_URL,
      target: "_blank",
      accent: "#25D366",
      testid: "msb-whatsapp",
    },
    {
      key: "email",
      label: "Email",
      icon: Mail,
      href: `mailto:${EMAIL}`,
      accent: "var(--accent-crimson-hover)",
      testid: "msb-email",
    },
  ];

  return (
    <nav
      aria-label="Quick contact"
      data-testid="mobile-sticky-bar"
      className="md:hidden fixed bottom-0 left-0 right-0 z-40 backdrop-blur-xl"
      style={{
        background: "var(--surface-glass)",
        borderTop: "1px solid var(--border)",
        paddingBottom: "env(safe-area-inset-bottom, 0px)",
        boxShadow: "0 -10px 30px rgba(0,0,0,0.25)",
      }}
    >
      <ul className="grid grid-cols-3">
        {items.map((it) => {
          const Icon = it.icon;
          return (
            <li key={it.key}>
              <a
                href={it.href}
                target={it.target}
                rel={it.target ? "noopener noreferrer" : undefined}
                data-testid={it.testid}
                className="flex flex-col items-center justify-center gap-1 py-3 transition-colors"
                style={{ color: "var(--text)" }}
              >
                <span
                  className="w-9 h-9 flex items-center justify-center btn-sharp"
                  style={{
                    border: `1px solid ${it.accent}`,
                    color: it.accent,
                    background: "var(--accent-blue-soft)",
                  }}
                >
                  <Icon className="w-4 h-4" strokeWidth={1.8} />
                </span>
                <span
                  className="font-mono-spec text-[10px] tracking-[0.18em] uppercase"
                  style={{ color: "var(--text-muted)" }}
                >
                  {it.label}
                </span>
              </a>
            </li>
          );
        })}
      </ul>
    </nav>
  );
};

export default MobileStickyBar;
